/**
 * ForgotPasswordPage
 * Kitchly v0.5.0
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { auth } from '../services/api';
import './AuthPages.css';

function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await auth.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-logo">
        <h1>{t('app.name')}</h1>
      </div>

      <div className="auth-card">
        <h2>{t('auth.resetPassword')}</h2>

        {sent ? (
          <div className="auth-success">
            {t('auth.resetSent')}
          </div>
        ) : (
          <>
            {error && <div className="auth-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label" htmlFor="email">{t('auth.email')}</label>
                <input
                  id="email"
                  type="email"
                  className="form-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  autoFocus
                />
              </div>

              <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
                {loading ? t('common.loading') : t('auth.sendResetLink')}
              </button>
            </form>
          </>
        )}

        <div className="auth-footer">
          <Link to="/login">{t('common.back')} {t('auth.login')}</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
